import { Component } from '@angular/core';

@Component({
    selector: 'oha-miscellaneous',
    template: ` <router-outlet></router-outlet> `,
})
export class MiscellaneousComponent {}
